export const MOBILE_OTP = 'LOGIN/MOBILE_OTP/NEW/UPDATE';